import AboutUsHero from "./AboutUSHero";
import OurJourney from "./ourJourney";
import VisionAndMission from "./ourVisionAndMission";
import WhoWeAre from "./whoWeAre";
import WhyChooseUS from "./whyChooseUS";

const AboutUs = () => {
  return (
    <main>
      <AboutUsHero />
      <WhoWeAre />
      <VisionAndMission />
      <WhyChooseUS />
      <OurJourney />
    </main>
  );
};

export default AboutUs;
